import { CheckBox } from "components/CheckBox/CheckBox";
import FormGeneratorComponent from "helper/FormGenerator";
import { formatDate } from "helper/dateFormat";
import { getCurrency, numberFormat } from "helper/numberFormat";
import { useSnackbar } from "notistack";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { eventsSlice } from "services/api/events";
import { ReactComponent as DateIcon } from "assets/icons/CustomDateIconGray.svg";
import TimeIcon from "assets/icons/TimeIcon.png";
import { Products } from './Products/Products';
import { AddonsTitle, EventDateRow, EventDatesGrid, ProductCard, ProductWrapper, TicketContent, TicketWrapper, ValidationIcon, ValidationItems, ValidationWrapper } from './Thems';
import { getAuthenticated } from "utils/functions";
import { Fonts, FontWeights, FontColors } from "theme/fontConfig";


export const Ticket = ({ index, formik,ticketUniqueId,setIsCheckedApplay,isCheckedApplay,submitButton,totalProducts,handleTotalForPay, checkFormDataValidation, updateTicketAfterAppliedCheckBox, selectedEventDates, setSelectedEventDates, selectedVariants, setSelectedVariants}) => {
  const { FormDataEvent,eventData,ticketTypeList,ticketTypeVariants} = useSelector(
    (state) => state?.Events
  );
  const isAuthenticated = getAuthenticated();
  const currency = getCurrency();
  const [data, setData] = useState([]);
  const [openMultiCards, setOpenMultiCards] = useState({});
  const dispatch = useDispatch();
  const { numberOfTickets } = useSelector((state) => state?.Events);
  const { products } = useSelector((state) => state?.Events);
  const { varients } = useSelector((state) => state?.Events);
  const { selectedValue } = useSelector((state) => state?.Events);
  const productsData=formik.values.ticketsData[index]
  const  formDataReservation  = formik?.values?.registrationForm || [];



    useEffect(()=>{ 
      //Restractating data for radio and multi checkbox 
         const test = FormDataEvent?.length > 0 && FormDataEvent?.map((item,i)=>{
            if(item?.options){
                return {
                  ...item,
                  options:item?.options?.map((val)=>{
                    return{
                      ...val,
                      key:`${val.key}_${index}`,
                    }
                  })
                }
              }else{
                return {
                  ...item,
                }
              }
              })
              setData(test)
  },[FormDataEvent])

  const handleAddDropdown = (type,id,product,ticketObjectId,varientsAfterDropDeleted) => {
    const options = []
    // Loop on variantInfo inside product to get options for each dropDown 
    const data = product?.variantInfo?.map((obj) => Object.keys(obj).map((key, index) => {
      options.push({option:key,quantity:obj[key]?.quantity || "infinit",mainQuantity:obj[key]?.quantity || "infinit"})
      
    }))
    if(type === 'increment'){
     // Add New drop down when the user click on increment button 
    const newDropdown = {
      id:id,
      options: options,
      selectedValue:""
    };
    formik.setFieldValue(`ticketsData.[${index}].[${ticketObjectId}].dropdowns`,[...formik?.values?.ticketsData[index]?.[ticketObjectId]?.dropdowns, newDropdown]);
  }else{
    
    const lastObjIndex = formik?.values?.ticketsData[index]?.[ticketObjectId]?.dropdowns.length -1 
    const lastObj =formik?.values?.ticketsData[index]?.[ticketObjectId]?.dropdowns[lastObjIndex]
    // if the user selected value inside drop down that mean we add it inside selectedValue array in this case we can remove the last obj when he click on decremnt button  
    if(lastObj.selectedValue !== ''){
      const newData = { ...selectedValue[0] }; // Create a shallow copy
      if (newData?.[product?.title]?.length >0) {
        // Remove from varients
        const VarientIndex = newData?.[product?.title]?.length -1
        const changeCounterValue = data && varients?.[ticketObjectId]?.variantsInfo?.map((varient)=>{
        if(varient.option === newData?.[product?.title]?.[VarientIndex]?.value){
              return { ...varient, counterValue : varient?.counterValue - 1}; 
          }else{
            return { ...varient}
          }
        })
        dispatch(eventsSlice.actions.setVarients({...varients,[ticketObjectId]:{...varientsAfterDropDeleted[ticketObjectId],variantsInfo:changeCounterValue}}));
        // Remove from selectedValue
        const arrayWithoutLastObj = newData[product?.title].slice(0, -1); // Remove the object at the last index
        const DataAfterRemoving= {...selectedValue[0],[product?.title]:arrayWithoutLastObj} // get the prevous data from array and add the new after removing
        // remove the object if there is no data inside array of thid object
        const filteredData = Object.fromEntries( Object.entries(DataAfterRemoving).filter(([k, v]) => v.length > 0));
        // chyeck if we have date add it inside array or return empty array
        const finalData = Object.keys(filteredData)?.length > 0 ? [filteredData] : []
       
        // to remove from selectedValue 
        dispatch(eventsSlice.actions.setSelectedValue({data:finalData,productIndex:ticketObjectId,productTitle:product.title,
          dropdownIndex:selectedValue[0]?.[product.title]?.length -1,
          type:'remove'}));
      }
    }else{
      dispatch(eventsSlice.actions.setVarients({...varients,[ticketObjectId]:{...varientsAfterDropDeleted[ticketObjectId]}}));
    }
    // Remove last drop down when the user click on decrement button
    const removeLastDropDown = formik?.values?.ticketsData[index]?.[ticketObjectId]?.dropdowns.slice(0, -1);
    formik.setFieldValue(`ticketsData.[${index}].[${ticketObjectId}].dropdowns`,removeLastDropDown);

  }
  };
  // Function to increment the counter for a specific object by a given value
  const incrementCounter = (id,product,productId,ticketObjectId) => {
    const increment=  productsData.map(obj =>{return obj._id === id ? { ...obj, counter: obj.counter + 1  } : obj});
    formik.setFieldValue(`ticketsData.[${index}]`, increment);
    // check if we gave variant for this product or not 
    const productVariant= {...varients}
    const newNumber = (productVariant[ticketObjectId]?.numberOfDrops || 0) + 1;
    const newCounter = (productVariant?.counterValue || 0) + 1;
    const newCounter2 = (productVariant[ticketObjectId]?.counterValue || 0) + 1;
    if(product.variant){
      const incrementNumberOfDrops = {...productVariant,[ticketObjectId] : 
        {...productVariant[ticketObjectId] ,numberOfDrops:newNumber} }
      dispatch(eventsSlice.actions.setVarients(incrementNumberOfDrops));
      handleAddDropdown("increment",productId,product,ticketObjectId)
    }else{
      const incrementCounterValue =productVariant[ticketObjectId]?.quantity !== 'noLimit'? {...productVariant,[ticketObjectId] : {...(productVariant[ticketObjectId] || {}) ,
        counterValue: newCounter2
      }} : {...productVariant,
        counterValue: newCounter
      }
      dispatch(eventsSlice.actions.setVarients(incrementCounterValue));
    }
    
  };
  
  // Function to decrement the counter for a specific object by a given value
  const decrementCounter = (id,product,productId,ticketObjectId) => {
    const decrement =  productsData.map(obj =>{return  obj._id === id ? { ...obj, counter: obj.counter - 1 } : obj});
    formik.setFieldValue(`ticketsData.[${index}]`, decrement);
    if(product.variant){
    const decrementNumberOfDrops = {...varients,[ticketObjectId] : 
      {...varients[ticketObjectId] ,numberOfDrops:varients[ticketObjectId]?.numberOfDrops>0 ?varients[ticketObjectId]?.numberOfDrops -1:0 
    }}
    handleAddDropdown("decrement",productId,product,ticketObjectId,decrementNumberOfDrops)
  }else{
    const decrementCounterValue = {...varients,[ticketObjectId] : {...(varients[ticketObjectId] || {}) ,
      counterValue:varients[ticketObjectId]?.counterValue>0 ?  varients[ticketObjectId]?.counterValue - 1 :0
    }}
    dispatch(eventsSlice.actions.setVarients(decrementCounterValue));
  }

  };
 


const syncValuesWithFormik = (event) => {
     // Create a copy of the current formDataReservation
  const updatedFormDataReservation = [...formDataReservation];

  // Check if there is an existing entry with the current ticket id
  const existingEntryIndex = updatedFormDataReservation.findIndex((item) => item.id === ticketUniqueId);

  if (existingEntryIndex !== -1) {
    // If the entry exists, update its formData.
    // A calendar close without a new selection can make the form library
    // drop a DatePicker field from `event` entirely instead of reporting
    // its current value, so merge onto the previous formData: keep any
    // field missing from `event`, otherwise trust the incoming value
    // (including an intentional clear).
    const previousFormData = updatedFormDataReservation[existingEntryIndex]?.formData || [];
    const incomingFields = event.filter(Boolean);
    const incomingById = new Map(incomingFields.map((field) => [field.id, field]));

    const mergedFormData = previousFormData.map((previousField) => {
      const incomingField = incomingById.get(previousField.id);
      return incomingField || previousField;
    });

    incomingFields.forEach((incomingField) => {
      if (!previousFormData.some((previousField) => previousField.id === incomingField.id)) {
        mergedFormData.push(incomingField);
      }
    });

    updatedFormDataReservation[existingEntryIndex] = { ...updatedFormDataReservation[existingEntryIndex], formData: mergedFormData };
    formik.setFieldValue('registrationForm', updatedFormDataReservation);
    checkFormDataValidation(ticketUniqueId, updatedFormDataReservation);
  } else {
    return
  }

}


function replaceFields(formData,firstFourFields, checked) {
  // Extract the first 4 fields from the first object in formData

  // Check if the condition is met
  if (checked) {
      return formData.map(data => {
        return [...firstFourFields];
    });
  } else {
      return formData.map(data => {
          return [];
      });
  }
}

const isApplyAllEnabled = useMemo(() => {
  return formDataReservation?.[0]?.formData?.slice(0, 3).every(item => item.value.trim() !== "");
}, [formDataReservation]);

const handleApplayCheckBox = (e)=>{
  if(!isApplyAllEnabled) return;
  const doWeHaveValues = formDataReservation?.[0]?.formData?.filter((val)=>val.value)

  if(formDataReservation?.[0]?.formData?.length > 0 && doWeHaveValues?.length >0 ){

    setIsCheckedApplay(e?.target?.checked)

    localStorage.setItem("ApplayCheckBox",JSON.stringify(e?.target?.checked))

    if(!formDataReservation?.length && !formDataReservation[0]?.formData?.length) return;

    const checked = e?.target?.checked;
    const dataDistribution = formDataReservation?.map((item,index) => {
        if(index === 0) return {
          ...item,
          formData: formDataReservation?.[0]?.formData?.map((formItem,index) => {
            if(formItem?.name?.includes('date_picker')) {
              const datePickerField = document.querySelector(`#${formDataReservation?.[0]?.id} input[name="${formItem.name}"]`);
              return {
                ...formItem,
                value: datePickerField?.value || "",
              }
            } else {
              return {
                ...formItem,
                value: item?.formData[index]?.value || "",
              }
            }

          })
        }
        return {
          ...item,
          ...(checked ? {formData: formDataReservation?.[0]?.formData?.map((formItem,index) => {
            if(formItem?.name?.includes('date_picker')) {
              const datePickerField = document.querySelector(`#${formDataReservation?.[0]?.id} input[name="${formItem.name}"]`);
              return {
                ...formItem,
                value: datePickerField?.value || "",
              }
            } else if(index <=4 ) {
              return {
              ...formItem,
              ...(!checked ? {value: ""} : {}),
              }
            } else {
              return {
                ...formItem,
                value: item?.formData[index]?.value || "",
              }
            }
          
          }) } : {})
        }
    })
    formik.setFieldValue('registrationForm', dataDistribution);
   
    if(checked){
      updateTicketAfterAppliedCheckBox();
    }
  }
}


  const displayTicketName = () => {
      const ticket = ticketTypeList?.find((ticket) => ticket.id === ticketUniqueId);
      if(!ticket || eventData?.freeEvent) return `Ticket #${index+1} Information`
      return `${ticket?.name?.toLowerCase() === "ticket" ? "" : ticket?.name} Ticket #${ticket?.quantity} Information`
  }

  return (
    <>
    <TicketWrapper id={ticketUniqueId}> 
      <TicketContent>
        {formik.values?.errors && formik.values?.errors?.[index]?.formData.length>0&&
        <ValidationWrapper>
          <ValidationIcon/>
          <ValidationItems>
          {formik.values?.errors?.[index]?.formData?.map((error)=>(
            <li>{error.errorMessage}</li>
          ))}
        </ValidationItems>
        
        </ValidationWrapper>
        }
        {index ===0 && numberOfTickets?.length >1 && (
          <div
            style={isApplyAllEnabled ? {} : {
              pointerEvents: 'none',
              opacity: 0.7
            }}
          >
            <CheckBox 
              text="Apply the information below to all tickets" 
              onChange={handleApplayCheckBox} 
              checked={isCheckedApplay}
              disabled={!isApplyAllEnabled}
            />
          </div>
        )}
        <br />
        {data?.length > 0 && (
          <FormGeneratorComponent
            key={ticketUniqueId}
            formStructure={[...data]}
            syncValuesWithFormik={syncValuesWithFormik}
            isReadOnly ={isCheckedApplay && index !==0}
            formDataReservation={formDataReservation}
            index={index}
            answerData={formDataReservation?.[index]?.formData}
            button={submitButton}
          />
        )}
      </TicketContent>
    </TicketWrapper>
    {eventData?.multiEvents && (
      <ProductCard>
        <TicketContent>
          <ProductWrapper>
            <AddonsTitle>Event Dates</AddonsTitle>
            {(() => {
              const isGroup = eventData?.multiEventsType === "grouped";
              const isIndividual = eventData?.multiEventsType === "individual";

              // Derive multi-date variants from pricing
              const onRegPrice = eventData?.eventPricing?.prices?.find(
                (p) => p?.type === "onRegistration" && p?.variant
              );
              const rawVariantInfo = onRegPrice?.variantInfo || {};
              const multiDateVariants = Object.entries(rawVariantInfo)
                .filter(([, val]) => val?.eventDate)
                .map(([key, val]) => ({ key, ...val }));
              const hasMultiDateVariants = multiDateVariants.length > 0;

              if (isIndividual && hasMultiDateVariants) {
                // Group by exact datetime — same date+time → dropdown, same date+diff time → separate cards
                const dateGroups = {};
                multiDateVariants.forEach((v) => {
                  // Normalize to minute precision so child/adult variants at the
                  // same date+time always group together even if ms differ
                  const timeKey = v.eventDate
                    ? v.eventDate.substring(0, 16)
                    : v.key;
                  if (!dateGroups[timeKey]) dateGroups[timeKey] = [];
                  dateGroups[timeKey].push(v);
                });

                const allSelectedVariants = selectedVariants || [];
                const ticketVariantMap = allSelectedVariants[index] || {};

                const updateVariant = (dayKey, variantKey) => {
                  const next = [...allSelectedVariants];
                  const ticketMap = { ...(next[index] || {}) };
                  if (variantKey !== null && variantKey !== undefined) {
                    ticketMap[dayKey] = variantKey;
                  } else {
                    delete ticketMap[dayKey];
                  }
                  next[index] = ticketMap;
                  setSelectedVariants && setSelectedVariants(next);
                };

                const totalGroups = Object.keys(dateGroups).length;
                return (
                  <EventDatesGrid style={totalGroups > 6 ? { maxHeight: "200px", overflowY: "auto", alignContent: "start" } : {}}>
                    {Object.entries(dateGroups)
                      .sort(([a], [b]) => a.localeCompare(b))
                      .map(([dayKey, variants]) => {
                        const visibleVariants = isAuthenticated ? variants : variants.filter(v => !v.forMemberOnly);
                        const cardMemberOnly = !isAuthenticated && visibleVariants.length === 0;
                        const activeVariants = cardMemberOnly ? variants : visibleVariants;
                        const selectedVariantKey = dayKey in ticketVariantMap ? ticketVariantMap[dayKey] : undefined;
                        const hasSelection = selectedVariantKey !== undefined;
                        const v0 = activeVariants[0];
                        const date = formatDate({ date: v0.eventDate, formatType: "defaultWithUTC" });
                        const time = formatDate({ date: v0.eventDate, formatType: "timeUTC" });
                        const duration = v0.eventDuration?.key || "";
                        const isMulti = variants.length > 1;
                        const matchingDate = (eventData?.multiEventsDates || []).find(
                          (d) => d?.eventDate?.substring(0, 16) === dayKey
                        );
                        const label = matchingDate?.label || matchingDate?.variantName || matchingDate?.name || "";

                        const selectedVariant = isMulti
                          ? activeVariants.find((v) => v.key === selectedVariantKey)
                          : v0;
                        const price = !cardMemberOnly && selectedVariant?.amount > 0
                          ? numberFormat({ number: selectedVariant.amount, decimal: 2, style: "currency" })
                          : "";

                        const cardKey = `${index}-${dayKey}`;
                        const isOpen = !!openMultiCards[cardKey];
                        const isChecked = !cardMemberOnly && (hasSelection || (isMulti && isOpen));

                        const toggleCard = () => {
                          if (cardMemberOnly) return;
                          if (isMulti) {
                            if (isChecked) return;
                            setOpenMultiCards((prev) => ({ ...prev, [cardKey]: !prev[cardKey] }));
                          } else {
                            if (isChecked) updateVariant(dayKey, null);
                            else updateVariant(dayKey, v0.key);
                          }
                        };

                        const monthStr = v0.eventDate ? new Date(v0.eventDate).toLocaleDateString("en-US", { month: "short", timeZone: "UTC" }).toUpperCase() : "";
                        const dayNum  = v0.eventDate ? new Date(v0.eventDate).toLocaleDateString("en-US", { day: "2-digit", timeZone: "UTC" }) : "";
                        const yearStr = v0.eventDate ? new Date(v0.eventDate).toLocaleDateString("en-US", { year: "numeric", timeZone: "UTC" }) : "";
                        const dowStr  = v0.eventDate ? new Date(v0.eventDate).toLocaleDateString("en-US", { weekday: "short", timeZone: "UTC" }).toUpperCase() : "";
                        const heading = label ? label.charAt(0).toUpperCase() + label.slice(1) : date;

                        return (
                          <div
                            key={dayKey}
                            onClick={cardMemberOnly ? undefined : toggleCard}
                            style={{
                              background: cardMemberOnly ? "#F8F9FA" : isChecked ? "rgba(37,85,239,0.04)" : "#fff",
                              border: `1px solid ${cardMemberOnly ? "#E2E8F0" : isChecked ? "#2555EF" : "#E2E8F0"}`,
                              borderRadius: 12,
                              padding: "10px 12px",
                              display: "flex",
                              gap: 12,
                              cursor: cardMemberOnly ? "not-allowed" : "pointer",
                              transition: "border-color 0.15s, background 0.15s, box-shadow 0.15s",
                              boxShadow: isChecked ? "0 2px 8px rgba(37,85,239,0.08)" : "none",
                              boxSizing: "border-box",
                              width: "100%",
                              opacity: cardMemberOnly ? 0.7 : 1,
                            }}
                          >
                            {/* Date badge */}
                            <div style={{
                              background: cardMemberOnly ? "#F0F0F0" : "#EEF2FF",
                              borderLeft: `3px solid ${cardMemberOnly ? "#9CA3AF" : "#2555EF"}`,
                              borderRadius: 8,
                              padding: "8px 10px",
                              textAlign: "center",
                              minWidth: 48,
                              flexShrink: 0,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 2,
                              transition: "border-color 0.15s",
                            }}>
                              <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: cardMemberOnly ? "#9CA3AF" : "#2555EF", letterSpacing: "0.06em", lineHeight: 1 }}>{monthStr}</span>
                              <span style={{ fontSize: Fonts.GeneralHeaderFont.fontSize, fontWeight: Fonts.GeneralHeaderFont.fontWeight, color: cardMemberOnly ? "#9CA3AF" : "#0F172A", lineHeight: 1.1 }}>{dayNum}</span>
                              <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: FontColors.Slate9CA3AF, letterSpacing: "0.06em", lineHeight: 1 }}>{yearStr}</span>
                              <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: FontColors.Slate9CA3AF, letterSpacing: "0.06em", lineHeight: 1 }}>{dowStr}</span>
                            </div>

                            {/* Details */}
                            <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 4, justifyContent: "center" }}>
                              {/* Heading + Checkbox */}
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "6px" }}>
                                <span style={{ fontSize: Fonts.GeneralSmallHeaderFont.fontSize, fontWeight: Fonts.GeneralSmallHeaderFont.fontWeight, color: cardMemberOnly ? "#6B7280" : "#0F172A", lineHeight: 1.3, flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {heading}
                                </span>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (cardMemberOnly) return;
                                    if (isMulti) {
                                      if (isChecked) {
                                        if (hasSelection) updateVariant(dayKey, null);
                                        setOpenMultiCards((prev) => ({ ...prev, [cardKey]: false }));
                                      } else {
                                        setOpenMultiCards((prev) => ({ ...prev, [cardKey]: true }));
                                      }
                                    } else {
                                      toggleCard();
                                    }
                                  }}
                                  style={{
                                    width: 18, height: 18, borderRadius: 4, flexShrink: 0,
                                    border: cardMemberOnly ? "2px solid #D1D5DB" : isChecked ? "2px solid #2555EF" : "2px solid rgba(37,85,239,0.35)",
                                    background: cardMemberOnly ? "#E5E7EB" : isChecked ? "#2555EF" : "#fff",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    cursor: cardMemberOnly ? "not-allowed" : "pointer",
                                    transition: "background 0.15s, border 0.15s",
                                  }}
                                >
                                  {isChecked && (
                                    <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                                      <path d="M1 4L3.5 6.5L9 1" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                  )}
                                </div>
                              </div>

                              {/* Time + duration */}
                              {(!isMulti || hasSelection || cardMemberOnly) && (
                                <div style={{ fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Slate64748B, display: "flex", alignItems: "center", gap: 4 }}>
                                  🕑 {!cardMemberOnly && isMulti
                                    ? formatDate({ date: selectedVariant?.eventDate || v0.eventDate, formatType: "timeUTC" })
                                    : time}
                                  {duration ? ` · ${duration}` : ""}
                                </div>
                              )}

                              {/* Member Only label */}
                              {cardMemberOnly && (
                                <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: FontColors.Slate6B7280, background: "#E5E7EB", borderRadius: 4, padding: "2px 6px", display: "inline-block" }}>🔒 Members Only</span>
                              )}

                              {/* Price */}
                              {price && (
                                <span style={{ fontSize: Fonts.GeneralSmallLabelFont.fontSize, fontWeight: FontWeights.Bold, color: FontColors.Blue2555EF }}>{price}</span>
                              )}

                              {/* Hint / Dropdown */}
                              {!cardMemberOnly && isMulti && !isChecked && (
                                <span style={{ fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Blue2555EF, opacity: 0.7 }}>
                                  {activeVariants.length} options — Tick to select
                                </span>
                              )}
                              {!cardMemberOnly && isMulti && isChecked && (
                                <div onClick={(e) => e.stopPropagation()} style={{ width: "100%", marginTop: 6 }}>
                                  <select
                                    value={hasSelection ? (selectedVariantKey ?? "") : ""}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      updateVariant(dayKey, val === "" ? null : val);
                                    }}
                                    style={{
                                      width: "100%",
                                      padding: "5px 28px 5px 10px",
                                      fontSize: Fonts.GeneralCaptionFont.fontSize,
                                      fontFamily: "inherit",
                                      fontWeight: hasSelection ? FontWeights.SemiBold : FontWeights.Regular,
                                      color: hasSelection ? "#002E5C" : "#94A3B8",
                                      backgroundColor: hasSelection ? "rgba(37,85,239,0.06)" : "#fff",
                                      border: hasSelection ? "1.5px solid #2555EF" : "1px solid rgba(37,85,239,0.3)",
                                      borderRadius: "6px",
                                      outline: "none",
                                      appearance: "none",
                                      WebkitAppearance: "none",
                                      backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%232555EF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                                      backgroundRepeat: "no-repeat",
                                      backgroundPosition: "right 10px center",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <option value="" disabled style={{ color: FontColors.Slate94A3B8, fontWeight: FontWeights.Regular }}>Select option...</option>
                                    {variants.map((v) => {
                                      const vAvail = v.infiniteQuantity ? Infinity : Math.max(0, (v.quantity || 0) - (v.reserveProduct || 0));
                                      const vSoldOut = !v.infiniteQuantity && vAvail <= 0;
                                      const isMemberOnly = v.forMemberOnly && !isAuthenticated;
                                      const isDisabled = vSoldOut || isMemberOnly;
                                      const vPrice = v.amount > 0 ? ` · ${numberFormat({ number: v.amount, decimal: 2, style: "currency" })}` : "";
                                      const displayLabel = v.variantLabel || v.dateLabel || v.key;
                                      const suffix = vSoldOut ? " (Sold Out)" : isMemberOnly ? " (Member Only)" : "";
                                      return (
                                        <option key={v.key} value={v.key} disabled={isDisabled} style={{ color: isDisabled ? "#94A3B8" : "#0F172A", fontWeight: FontWeights.Regular }}>
                                          {displayLabel}{vPrice}{suffix}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                  </EventDatesGrid>
                );
              }

              // Grouped or individual without multiDateVariants → checkbox UI
              if (!eventData?.multiEventsDates?.length) return null;
              return (
                <EventDatesGrid style={eventData.multiEventsDates.length > 6 ? { maxHeight: "200px", overflowY: "auto", alignContent: "start" } : {}}>
                  {eventData.multiEventsDates.map((dateItem, idx) => {
                    const dateMemberOnly = !isAuthenticated && dateItem?.forMemberOnly;
                    const label = dateItem?.label || dateItem?.variantName || dateItem?.name || "";
                    const date = formatDate({ date: dateItem?.eventDate, formatType: "defaultWithUTC" });
                    const time = formatDate({ date: dateItem?.eventDate, formatType: "timeUTC" });
                    const duration = dateItem?.eventDuration?.key || "";
                    const price = !dateMemberOnly && dateItem?.amount > 0 ? numberFormat({ number: dateItem.amount, decimal: 2, style: "currency" }) : "";
                    const ticketDates = (selectedEventDates || [])[index] || [];
                    const isChecked = !dateMemberOnly && (isGroup || ticketDates.includes(idx));

                    const toggleDate = () => {
                      if (dateMemberOnly) return;
                      const allDates = selectedEventDates || [];
                      const current = allDates[index] || [];
                      const updated = isChecked
                        ? current.filter((i) => i !== idx)
                        : [...current, idx];
                      const newAllDates = [...allDates];
                      newAllDates[index] = updated;
                      setSelectedEventDates && setSelectedEventDates(newAllDates);
                    };

                    const dow = formatDate({ date: dateItem?.eventDate, formatType: "dayOfWeek" }) ||
                      (dateItem?.eventDate ? new Date(dateItem.eventDate).toLocaleDateString("en-US", { weekday: "short", timeZone: "UTC" }).toUpperCase() : "");
                    const monthStr = dateItem?.eventDate ? new Date(dateItem.eventDate).toLocaleDateString("en-US", { month: "short", timeZone: "UTC" }).toUpperCase() : "";
                    const dayNum = dateItem?.eventDate ? new Date(dateItem.eventDate).toLocaleDateString("en-US", { day: "2-digit", timeZone: "UTC" }) : "";
                    const yearStr = dateItem?.eventDate ? new Date(dateItem.eventDate).toLocaleDateString("en-US", { year: "numeric", timeZone: "UTC" }) : "";
                    return (
                      <div
                        key={idx}
                        onClick={!isGroup && !dateMemberOnly ? toggleDate : undefined}
                        style={{
                          background: dateMemberOnly ? "#F8F9FA" : isChecked ? "rgba(37,85,239,0.04)" : "#fff",
                          border: `1px solid ${dateMemberOnly ? "#E2E8F0" : isChecked ? "#2555EF" : "#E2E8F0"}`,
                          borderRadius: 12,
                          padding: "10px 12px",
                          display: "flex",
                          gap: 12,
                          cursor: dateMemberOnly ? "not-allowed" : isGroup ? "default" : "pointer",
                          transition: "border-color 0.15s, background 0.15s, box-shadow 0.15s",
                          boxShadow: isChecked ? "0 2px 8px rgba(37,85,239,0.08)" : "none",
                          boxSizing: "border-box",
                          width: "100%",
                          opacity: dateMemberOnly ? 0.7 : 1,
                        }}
                      >
                        {/* Date badge */}
                        <div style={{
                          background: dateMemberOnly ? "#F0F0F0" : "#EEF2FF",
                          borderLeft: `3px solid ${dateMemberOnly ? "#9CA3AF" : "#2555EF"}`,
                          borderRadius: 8,
                          padding: "8px 10px",
                          textAlign: "center",
                          minWidth: 48,
                          flexShrink: 0,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 2,
                          transition: "border-color 0.15s",
                        }}>
                          <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: dateMemberOnly ? "#9CA3AF" : "#2555EF", letterSpacing: "0.06em", lineHeight: 1 }}>{monthStr}</span>
                          <span style={{ fontSize: Fonts.GeneralHeaderFont.fontSize, fontWeight: Fonts.GeneralHeaderFont.fontWeight, color: dateMemberOnly ? "#9CA3AF" : "#0F172A", lineHeight: 1.1 }}>{dayNum}</span>
                          <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: FontColors.Slate9CA3AF, letterSpacing: "0.06em", lineHeight: 1 }}>{yearStr}</span>
                          <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: FontColors.Slate9CA3AF, letterSpacing: "0.06em", lineHeight: 1 }}>{dow}</span>
                        </div>

                        {/* Details */}
                        <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 3, justifyContent: "center" }}>
                          <div style={{ fontSize: Fonts.GeneralSmallHeaderFont.fontSize, fontWeight: Fonts.GeneralSmallHeaderFont.fontWeight, color: dateMemberOnly ? "#6B7280" : "#0F172A" }}>
                            {label ? label.charAt(0).toUpperCase() + label.slice(1) : `Session ${idx + 1}`}
                          </div>
                          <div style={{ fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Slate64748B, display: "flex", alignItems: "center", gap: 4 }}>
                            🕑 {time}{duration ? ` · ${duration}` : ""}
                          </div>
                          {dateMemberOnly && (
                            <span style={{ fontSize: Fonts.GeneralSmallLabelFont.fontSize, color: FontColors.Purple7C3AED, fontWeight: Fonts.GeneralSmallLabelFont.fontWeight }}>(Member Only)</span>
                          )}
                          {price && (
                            <span style={{ fontSize: Fonts.GeneralSmallLabelFont.fontSize, fontWeight: FontWeights.Bold, color: FontColors.Blue2555EF }}>{price}</span>
                          )}
                        </div>

                        {/* Checkbox */}
                        <div
                          onClick={(e) => { e.stopPropagation(); if (!isGroup && !dateMemberOnly) toggleDate(); }}
                          style={{
                            width: 18, height: 18, borderRadius: 4, flexShrink: 0, alignSelf: "center",
                            border: dateMemberOnly ? "2px solid #D1D5DB" : isChecked ? "2px solid #2555EF" : "2px solid rgba(37,85,239,0.35)",
                            background: dateMemberOnly ? "#E5E7EB" : isChecked ? (isGroup ? "rgba(37,85,239,0.15)" : "#2555EF") : "#fff",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            cursor: dateMemberOnly ? "not-allowed" : isGroup ? "not-allowed" : "pointer",
                            transition: "background 0.15s, border 0.15s",
                          }}
                        >
                          {isChecked && (
                            <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                              <path d="M1 4L3.5 6.5L9 1" stroke={isGroup ? "#2555EF" : "#fff"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </EventDatesGrid>
              );
            })()}
          </ProductWrapper>
        </TicketContent>
      </ProductCard>
    )}
    {products?.length > 0 && !eventData.freeEvent && (
      <ProductCard>
        <TicketContent>
          <ProductWrapper>
            <AddonsTitle>Select Add-ons below</AddonsTitle>
            <Products
              index={index}
              productsData={productsData}
              formik={formik}
              ticketUniqueId={ticketUniqueId}
              incrementCounter={incrementCounter}
              decrementCounter={decrementCounter}
              dropdowns={formik?.values?.ticketsData[index]?.dropdowns}
              totalProducts={totalProducts}
              handleTotalForPay={handleTotalForPay}
            />
          </ProductWrapper>
        </TicketContent>
      </ProductCard>
    )}
    </>
  );
};
